module.exports = __webpack_public_path__ + "static/logo-a8af8248b0c83059337ec74d0d2b0765.png";